/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled, {css} from "styled-components";
import Colors from 'constants/Colors';
import { FontWeight, FiraSansBold } from 'components/Text';
import { Breakpoints } from "constants/Breakpoints";


export const Text = styled.text`
  color: ${Colors.GRAY[6]};
  font-weight: ${FontWeight.SemiBold};
  text-transform: uppercase;
  font-size: 16px;
  cursor: pointer;
`;


export const Title = styled.label`
  font-size: 16px;
  color: ${Colors.GRAY[6]};
  ${FiraSansBold}
  `;
  

  export const PlaceHolder = styled.label`
  display: block;
  padding: 0.75rem 3.75rem;
  text-transform: uppercase;
  -webkit-letter-spacing: -0.5px;
  -moz-letter-spacing: -0.5px;
  -ms-letter-spacing: -0.5px;
  letter-spacing: -0.5px;
  font-size: 16px;
  height: 42px;
  width: auto;
  white-space: nowrap;
  font-family: "Quicksand";
  font-weight: bold;
  font-style: normal;
  border: 0 none;
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
  -webkit-transition: background-color 0.15s ease, color 0.15s ease,
    width 0.3s ease, border 0.5s ease, border-color 0.5s ease,
    box-shadow 0.15s ease;
  transition: background-color 0.15s ease, color 0.15s ease, width 0.3s ease,
    border 0.5s ease, border-color 0.5s ease, box-shadow 0.15s ease;
  text-align: center;
  color: #ffffff;
  background-color: ${Colors.BLUE};
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.1);
`;


export const TagInput2 = styled.input`
  flex: 1;
  display: none;
  border: none;
  width: 100%;

  &:focus {
    outline: transparent;
  }
`;

export const TagInput = styled.input`
  flex: 1;
  display: none;
  border: none;
  width: 100%;

  &:focus {
    outline: transparent;
  }
`;

export const ButtonContent = styled.div`
    display:flex;
    flex-direction:row;
    justify-content: space-evenly;
    background-color:#FFF;  
    
    @media (max-width: ${Breakpoints.lg}) {  
      flex-wrap: wrap;
      padding-right: 10px;
      width: 100%;
    }
`;

export const CalendarContainer = styled.div`
  z-index: 55;
  /* top: 75px;
  right: 14px; */
  position: absolute;
`;

export const BorderSwitch = styled.div`  
  background: ${Colors.GRAY[6]};
  padding-left: 1px;
  border-radius: 14px;
  width: 57px;
  padding-top: 1px;
  height: 30px;
  display: -webkit-inline-box;

  ${({ newBorder }) =>
    newBorder
      ? css`
          margin-top: 10px;
        `
      : ""}
`;



